<template>
  <div>
    <b-carousel id="carousel-1" v-model="slide" background="#ababab">
      <b-carousel-slide>
        <template #img>
          <div
            class="w-100 home-slider-img "
            alt="image slot"
            :style="
              `background: url(${banner ||
                'https://buzhistu-1251664918.cos.ap-shanghai.myqcloud.com/tianxin/slider.jpg'}) no-repeat top center scroll;background-size: cover;`
            "
          >
            <div class="w-100 row  align-items-center home-slider">
              <slot class="col"></slot>
            </div>
          </div>
        </template>
      </b-carousel-slide>

      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      <!-- <b-carousel-slide caption="Blank Image" img-blank img-alt="Blank image">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          eros felis, tincidunt a tincidunt eget, convallis vel est. Ut
          pellentesque ut lacus vel interdum.
        </p>
      </b-carousel-slide> -->
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    banner: {
      type: String,
    },
  },
  data() {
    return {
      slotHeight: 0,
      slide: 0,
      sliding: null,
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>
<style>
.home-slider {
  height: 50vw;
  max-height: 600px;
  width: 100vw;
  /*图片的宽高为440*440，而元素相对区域高度为50 */
}
.home-slider-img {
  height: 50vw;
  max-height: 600px;
  width: 100vw;
}

@media only screen and (max-width: 500px) {
  .home-slider {
    height: 80vw;
    width: 100vw;
    /*图片的宽高为440*440，而元素相对区域高度为50 */
  }
  .home-slider-img {
    height: 80vw;
    width: 100vw;
  }
}
</style>
